import React, { useState, useEffect } from "react";
import {
  ChevronLeft,
  ChevronRight,
  Gift,
  Code,
  Shield,
  Users,
  Rocket,
  Wind,
} from "lucide-react";
import {
  Badge,
  CTAButton,
  Dot,
  Dots,
  GlowEffect,
  IconContainer,
  NavButton,
  Slide,
  SlideItem,
  SlideItems,
  SlideSubtext,
  SlideText,
  SlideTitle,
  SliderContainer,
  SliderWrapper,
} from "./OfferStyles";
import OfferForm from "./OfferForm";
import Navbar from "../../components/shared-components/navbar/Navbar";
import Footer from "../../components/shared-components/footer/Footer";

export const slides = [
  {
    id: 1,
    text: "How AI Solves It\n20% OFF for First-Time Projects!",
    details: [
      "Turn Everyday Problems into Intelligent Solutions.",
      "Get 20% OFF your first AI project — from concept to deployment, we make AI work for your business.",
    ],
  },
  {
    id: 2,
    text: "Project Launch Offer\n20% OFF for First-Time Clients!",
    details: [
      "Build smarter. Launch faster.",
      "Enjoy 20% OFF your first project with us — whether it’s web, mobile, or software development, we help you bring your ideas to life with precision and speed.",
    ],
  },
];

const offers = [
  {
    title: "How AI Solves It\n20% OFF for First-Time Projects!",
    subtext:
      "Turn Everyday Problems into Intelligent Solutions.\nGet 20% OFF your first AI project — from concept to deployment, we make AI work for your business.",
    items: [
      {
        icon: <Gift />,
        text: "20% OFF on custom AI development for first-time clients",
      },
      {
        icon: <Rocket />,
        text: "From automation to predictive insights — tailor-made for your business",
      },
      {
        icon: <Code />,
        text: "End-to-end setup: strategy, design, and implementation",
      },
      {
        icon: <Wind />,
        text: "25% Faster Delivery. Zero Compromise.",
      },
    ],
    cta: "Launch Your AI Journey Today",
  },
  {
    title: "Project Launch Offer\n20% OFF for First-Time Clients!",
    subtext:
      "Build smarter. Launch faster.\nEnjoy 20% OFF your first project with us — whether it’s web, mobile, or software development, we help you bring your ideas to life with precision and speed.",
    items: [
      {
        icon: <Gift />,
        text: "20% OFF any development project for new clients",
      },
      {
        icon: <Users />,
        text: "Expert team across web, app, and cloud solutions",
      },
      {
        icon: <Rocket />,
        text: "Full project cycle: design, development, and deployment",
      },
      {
        icon: <Wind />,
        text: "25% Faster Delivery. Zero Compromise.",
      },
    ],
    cta: "Start Your Project Today",
  },
];

function App() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const handleCta = () => {
    const formCont = document.getElementById("offerFormId");
    formCont?.scrollIntoView({ behavior: "smooth" });
  };

  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev + 1) % offers.length);
    setTimeout(() => setIsAnimating(false), 600);
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => (prev - 1 + offers.length) % offers.length);
    setTimeout(() => setIsAnimating(false), 600);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 40000);
    return () => clearInterval(interval);
  }, []);

  const currentOffer = offers[currentSlide];

  return (
    <SliderContainer>
      <Navbar />

      <GlowEffect />
      <SliderWrapper>
        <Slide $isAnimating={isAnimating}>
          <Badge>
            <Gift size={16} />
            <span>Special Offer</span>
          </Badge>
          <SlideTitle
            dangerouslySetInnerHTML={{
              __html: currentOffer.title.replace(/\n/g, "<br>"),
            }}
          />
          {currentOffer.subtext && (
            <SlideSubtext
              dangerouslySetInnerHTML={{
                __html: currentOffer.subtext.replace(/\n/g, "<br>"),
              }}
            />
          )}
          <SlideItems>
            {currentOffer.items.map((item, idx) => (
              <SlideItem key={idx}>
                <IconContainer>{item.icon}</IconContainer>
                <SlideText dangerouslySetInnerHTML={{ __html: item.text }} />
              </SlideItem>
            ))}
          </SlideItems>
          <CTAButton onClick={handleCta}>
            {currentOffer.cta || "Get Offer Now"}
          </CTAButton>
          <NavButton $left $isAnimating={isAnimating} onClick={prevSlide}>
            <ChevronLeft size={24} />
          </NavButton>
          <NavButton $isAnimating={isAnimating} onClick={nextSlide}>
            <ChevronRight size={24} />
          </NavButton>
          <Dots>
            {offers.map((_, idx) => (
              <Dot
                key={idx}
                $active={idx === currentSlide}
                onClick={() => setCurrentSlide(idx)}
              />
            ))}
          </Dots>
        </Slide>
      </SliderWrapper>

      <section
        style={{ marginTop: "2rem", width: "98%", position: "relative" }}
        id="offerFormId"
      >
        <OfferForm />
      </section>

      <Footer />
    </SliderContainer>
  );
}

export default App;
